import '../../App.css'
import React from 'react'

const WrappedPage = () => {
  return (
    <div id="page-wrapped" className="page-active">
      <div className="page-header">
        <div className="page-title">Your 2026 Wrapped</div>
      </div>

      <div className="wrapped-locked">
        <div className="lock-icon">
          <i className="ti ti-lock" aria-hidden="true"></i>
        </div>

        <div className="wrapped-title">FieldDay Wrapped</div>

        <div
          className="wrapped-sub"
          style={{
            marginBottom: 4,
            fontSize: "15px",
            fontWeight: 600,
            color: "var(--fd-gold)",
          }}
        >
          Your Year in Sports
        </div>

        <div className="wrapped-sub">
          Your 2026 Wrapped graphic unlocks December 31st. Keep watching,
          chatting & rating games — your habits are being tracked all year.
        </div>

        <div className="countdown-grid">
          <div className="countdown-block">
            <div className="countdown-num" id="cnt-days">
              161
            </div>
            <div className="countdown-label">Days</div>
          </div>

          <div className="countdown-block">
            <div className="countdown-num" id="cnt-hrs">
              9
            </div>
            <div className="countdown-label">Hours</div>
          </div>

          <div className="countdown-block">
            <div className="countdown-num" id="cnt-min">
              10
            </div>
            <div className="countdown-label">Mins</div>
          </div>
        </div>

        <div
          style={{
            background: "var(--fd-surface)",
            border: "1px solid var(--fd-border)",
            borderRadius: "12px",
            padding: "20px 28px",
            maxWidth: "380px",
            width: "100%",
            textAlign: "left",
          }}
        >
          <div
            style={{
              fontFamily: "var(--font-head)",
              fontSize: "13px",
              fontWeight: 800,
              letterSpacing: "1px",
              textTransform: "uppercase",
              color: "var(--fd-muted)",
              marginBottom: "14px",
            }}
          >
            Your Stats So Far
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "16px",
            }}
          >
            <div>
              <div
                style={{
                  fontFamily: "var(--font-head)",
                  fontSize: "28px",
                  fontWeight: 900,
                  color: "var(--fd-gold)",
                }}
              >
                184
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: "var(--fd-muted)",
                }}
              >
                Games watched
              </div>
            </div>

            <div>
              <div
                style={{
                  fontFamily: "var(--font-head)",
                  fontSize: "28px",
                  fontWeight: 900,
                  color: "var(--fd-green-light)",
                }}
              >
                62
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: "var(--fd-muted)",
                }}
              >
                Reviews written
              </div>
            </div>

            <div>
              <div
                style={{
                  fontFamily: "var(--font-head)",
                  fontSize: "28px",
                  fontWeight: 900,
                  color: "var(--fd-blue)",
                }}
              >
                3,241
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: "var(--fd-muted)",
                }}
              >
                Live chats sent
              </div>
            </div>

            <div>
              <div
                style={{
                  fontFamily: "var(--font-head)",
                  fontSize: "28px",
                  fontWeight: 900,
                  color: "var(--fd-red)",
                }}
              >
                OKC
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: "var(--fd-muted)",
                }}
              >
                #1 most watched
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            marginTop: "16px",
            fontSize: "12px",
            color: "var(--fd-muted)",
          }}
        >
          Share your preview ↗
        </div>
      </div>
    </div>
  );
}

export default WrappedPage;
